import CardMoreInfo from './CardMoreInfo';
import ErorBundary from '../../ErrorBoundary';

export default function CardMoreInfoContainer() {
	return (
		<ErorBundary>
			<CardMoreInfo />
		</ErorBundary>
	);
}
